import { ApiResult } from 'src/Libs/api'
import { AuthFetchWithResponse } from 'src/Types/api'
import { AuthFetchError } from '@e3dc-react/shell/Types/api'
import { handleFetchError } from 'src/Libs/api/utils'
import { StatusCodes } from 'src/Libs/http-status-codes'
import { VerifyRequirementsDto } from './dto'

/**
 * Check system for possibility to infinity update by SN
 *
 * @param storageId
 * @param authFetch
 * @returns
 */
export const verifyRequirements = async (
  storageId: string | undefined,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<boolean, AuthFetchError | Error>> => {
  try {
    const response = await authFetch<VerifyRequirementsDto>({
      path: `hardware-tests/storages/${storageId}/infinity-update/verify-requirements`,
      method: 'GET',
      endpoint: process.env.REACT_APP_HARDWARE_TESTS_ENDPOINT,
    })

    if (response.status === StatusCodes.OK) {
      return new ApiResult<boolean, AuthFetchError | Error>(response.data.result, false)
    }

    return new ApiResult<boolean, AuthFetchError | Error>(null, true)
  } catch (error) {
    return handleFetchError<boolean>(error)
  }
}

/**
 * Start infinity update
 *
 * @param storageId
 * @param values
 * @param authFetch
 */
export const startInfinityUpdate = async (
  storageId: string | undefined,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<null, AuthFetchError | Error>> => {
  const response = await authFetch<null>({
    path: `hardware-tests/storages/${storageId}/infinity-update`,
    method: 'POST',
    endpoint: process.env.REACT_APP_HARDWARE_TESTS_ENDPOINT,
    payload: {},
  })

  if (response.status === StatusCodes.OK) {
    return new ApiResult<null, AuthFetchError | Error>(null, false)
  }

  return new ApiResult<null, AuthFetchError | Error>(null, true)
}
